/**
 * Represents the stage of the AI companion.
 */
var Stage;
(function (Stage) {
  /**
   * The AI companion is in the testing stage.
   */
  Stage["TEST"] = "test";
  /**
   * The AI companion is in the beta stage.
   */
  Stage["BETA"] = "beta";
  /**
   * The AI companion is in the gamma stage.
   */
  Stage["GAMMA"] = "gamma";
  /**
   * The AI companion is in the prod stage.
   */
  Stage["PROD"] = "prod";
})(Stage || (Stage = {}));

var AttachmentType;
(function (AttachmentType) {
  AttachmentType["FILE"] = "file";
  AttachmentType["ITEM"] = "item";
  AttachmentType["CLOUD"] = "cloud";
})(AttachmentType || (AttachmentType = {}));
var DownloadDocumentType;
(function (DownloadDocumentType) {
  DownloadDocumentType["MSDoc"] = "ms-doc";
  DownloadDocumentType["Text"] = "text";
  DownloadDocumentType["PDF"] = "pdf";
  DownloadDocumentType["HTML"] = "html";
  DownloadDocumentType["Markdown"] = "markdown";
})(DownloadDocumentType || (DownloadDocumentType = {}));
var DownloadContentType;
(function (DownloadContentType) {
  DownloadContentType["Markdown"] = "markdown";
  DownloadContentType["HTML"] = "html";
  DownloadContentType["Text"] = "text";
})(DownloadContentType || (DownloadContentType = {}));
var LegalAiCompanionEventNames;
(function (LegalAiCompanionEventNames) {
  LegalAiCompanionEventNames["OnUpdateCurrentPageId"] = "onUpdateCurrentPageId";
  LegalAiCompanionEventNames["OnSummarization"] = "onSummarization";
  LegalAiCompanionEventNames["OnChronology"] = "onChronology";
  LegalAiCompanionEventNames["OnGetListDocumentsComplete"] = "onGetListDocumentsComplete";
  LegalAiCompanionEventNames["OnGeneratePreSignedURLComplete"] = "onGeneratePreSignedURLComplete";
  LegalAiCompanionEventNames["OnGetListDocuments"] = "onGetListDocuments";
  LegalAiCompanionEventNames["OnGeneratePreSignedURL"] = "onGeneratePreSignedURL";
  LegalAiCompanionEventNames["OnGetOfficeContentResponse"] = "onGetOfficeContentResponse";
  LegalAiCompanionEventNames["OnGetOfficeContentRequest"] = "onGetOfficeContentRequest";
  LegalAiCompanionEventNames["OnCopyOrInsert"] = "onCopyOrInsert";
  LegalAiCompanionEventNames["OnGetPreviewPreSignedURL"] = "onGetPreviewPreSignedURL";
  LegalAiCompanionEventNames["OnGetPreviewPreSignedURLComplete"] = "onGetPreviewPreSignedURLComplete";
  LegalAiCompanionEventNames["OnMFWEventComplete"] = "onMFWEventComplete";
  LegalAiCompanionEventNames["OnGetApplicationContextResponse"] = "onGetApplicationContextResponse";
  LegalAiCompanionEventNames["OnGetApplicationContextRequest"] = "onGetApplicationContextRequest";
  LegalAiCompanionEventNames["OnContentSelectionChange"] = "onContentSelectionChange";
  LegalAiCompanionEventNames["OnProjectCreation"] = "onProjectCreation";
  LegalAiCompanionEventNames["OnProjectCreationComplete"] = "onProjectCreationComplete";
  LegalAiCompanionEventNames["OnSendOwnPromptWithDocuments"] = "onSendOwnPromptWithDocuments";
  LegalAiCompanionEventNames["OnDocumentsSelection"] = "onDocumentsSelection";
  LegalAiCompanionEventNames["OnDocumentSelectInAICompanion"] = "onDocumentSelectInAICompanion";
  LegalAiCompanionEventNames["OnNoDocuments"] = "onNoDocuments";
  LegalAiCompanionEventNames["OnSetDocumentGenAIResponseType"] = "onSetDocumentGenAIResponseType";
  LegalAiCompanionEventNames["OnLACDownloadDocument"] = "onLACDownloadDocument";
  LegalAiCompanionEventNames["OnCapabilityCompleteEvent"] = "onCapabilityCompleteEvent";
  LegalAiCompanionEventNames["OnFocusDocument"] = "onFocusDocument";
  LegalAiCompanionEventNames["OnNotifyMFE"] = "onNotifyMFE";
})(LegalAiCompanionEventNames || (LegalAiCompanionEventNames = {}));

/**
 * Represents the content type of a file.
 */
var ContentType;
(function (ContentType) {
  ContentType["TEXT"] = "text";
  ContentType["DOCUMENT"] = "document";
  ContentType["NONE"] = "none";
})(ContentType || (ContentType = {}));

/**
 * Represents the types of skills available.
 */
var SkillType;
(function (SkillType) {
  SkillType["Summarization"] = "summarization";
  SkillType["WorldKnowledge"] = "world knowledge";
  SkillType["KnowledgeBase"] = "knowledge base";
  SkillType["Chronology"] = "chronology";
  SkillType["FrequentlyAskedQuestions"] = "faq";
  SkillType["OwnPrompt"] = "own prompt";
  SkillType["ActionItems"] = "action items";
  SkillType["ContentEvaluation"] = "content evaluation";
  SkillType["CompareDocuments"] = "compare documents";
  SkillType["MultiDocumentChronology"] = "multi document chronology";
  SkillType["InvokeLLM"] = "invoke llm";
  SkillType["Patentable"] = "patentable";
  SkillType["InformationExtraction"] = "information extraction";
  SkillType["QuestionAnswering"] = "question answering";
  SkillType["Proofreading"] = "proofreading";
  SkillType["InsertionOrders"] = "insertion orders";
  SkillType["EvaluateIdea"] = "evaluate idea";
})(SkillType || (SkillType = {}));

var LegalAiStandAloneEventNames;
(function (LegalAiStandAloneEventNames) {
  LegalAiStandAloneEventNames["OnChooseOrUploadDocuments"] = "onChooseOrUploadDocuments";
  LegalAiStandAloneEventNames["OnClearDocumentSelection"] = "onClearDocumentSelection";
  LegalAiStandAloneEventNames["OnShowDocumentsDrawer"] = "onShowDocumentsDrawer";
  LegalAiStandAloneEventNames["OnRemoveDocumentDrawerFromContainer"] = "onRemoveDocumentDrawerFromContainer";
  LegalAiStandAloneEventNames["OnShowDocumentsUploadModal"] = "onShowDocumentsUploadModal";
})(LegalAiStandAloneEventNames || (LegalAiStandAloneEventNames = {}));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * Enum representing different event types that can occur during metric tracking
 */
var MetricEventType;
(function (MetricEventType) {
  /** Event when an operation is dropped or cancelled */
  MetricEventType["Dropped"] = "Dropped";
  /** Event when an operation completes successfully */
  MetricEventType["Success"] = "Success";
  /** Event when an operation is retried */
  MetricEventType["Retry"] = "Retry";
  /** Event when a user interaction click occurs */
  MetricEventType["Clicked"] = "Clicked";
  /** Event when an operation fails */
  MetricEventType["Failed"] = "Failed";
  /** Event when a generative AI request fails */
  MetricEventType["GenAIRequestFailed"] = "GenAIRequestFailed";
  /** Event when a value or state is changed */
  MetricEventType["Changed"] = "Changed";
  /** Event when an action or process is triggered */
  MetricEventType["Triggered"] = "Triggered";
  /** Event when an operation is started */
  MetricEventType["Initiated"] = "Initiated";
  /** Event when an operation is finished */
  MetricEventType["Completed"] = "Completed";
  /** Event when content or data is loaded */
  MetricEventType["Loaded"] = "Loaded";
  /** Event when validation checks fail */
  MetricEventType["ValidationFailed"] = "ValidationFailed";
  /** Event when a generative AI request initiation fails */
  MetricEventType["GenAIRequestInitiationFailed"] = "GenAIRequestInitiationFailed";
})(MetricEventType || (MetricEventType = {}));
/**
 * Enum representing different types of metrics that can be logged
 */
var LegalAIMetricType;
(function (LegalAIMetricType) {
  /** Events related to component capabilities */
  LegalAIMetricType["CAPABILITY_EVENTS"] = "CAPABILITY_EVENTS";
  /** HTTP request metrics */
  LegalAIMetricType["HTTP_REQUESTS"] = "HTTP_REQUESTS";
  /** Error events and exceptions */
  LegalAIMetricType["ERRORS"] = "ERRORS";
  /** Performance timing metrics */
  LegalAIMetricType["PERFORMANCE"] = "PERFORMANCE";
  /** Counter metrics */
  LegalAIMetricType["COUNTERS"] = "COUNTERS";
  /** Log events */
  LegalAIMetricType["LOG"] = "LOG";
})(LegalAIMetricType || (LegalAIMetricType = {}));
var MiscMetricNames;
(function (MiscMetricNames) {
  MiscMetricNames["NoRelevantInformationFound"] = "NoRelevantInformationFound";
})(MiscMetricNames || (MiscMetricNames = {}));
var InitiatedMetricNames;
(function (InitiatedMetricNames) {
  InitiatedMetricNames["InvokedAttachments"] = "InvokedAttachments";
})(InitiatedMetricNames || (InitiatedMetricNames = {}));
var ChangedEventMetricNames;
(function (ChangedEventMetricNames) {
  ChangedEventMetricNames["CapabilitySelection"] = "CapabilitySelection";
  ChangedEventMetricNames["AskQuestionUsingPrompt"] = "AskQuestionUsingPrompt";
  ChangedEventMetricNames["CombinedResponse"] = "CombinedResponse";
  ChangedEventMetricNames["SingleResponse"] = "SingleResponse";
  ChangedEventMetricNames["SelectAllDocuments"] = "SelectAllDocuments";
  ChangedEventMetricNames["DocumentSelected"] = "DocumentSelected";
})(ChangedEventMetricNames || (ChangedEventMetricNames = {}));
var ClickMetricsNames;
(function (ClickMetricsNames) {
  ClickMetricsNames["SkillButton"] = "SkillButton";
  ClickMetricsNames["SuggestedQuestionButton"] = "SuggestedQuestionButton";
  ClickMetricsNames["PositiveFeedbackButton"] = "PositiveFeedbackButton";
  ClickMetricsNames["NegativeFeedbackButton"] = "NegativeFeedbackButton";
  ClickMetricsNames["RegenerationMenuButton"] = "RegenerationMenuButton";
  ClickMetricsNames["CopyMenuButton"] = "CopyMenuButton";
  ClickMetricsNames["ResponseDownloadMenuButton"] = "ResponseDownloadMenuButton";
  ClickMetricsNames["InsertIntoButton"] = "InsertIntoButton";
  ClickMetricsNames["PreviewMenuButton"] = "PreviewMenuButton";
  ClickMetricsNames["FullScreenMenuButton"] = "FullScreenMenuButton";
  ClickMetricsNames["AskFollowUpButton"] = "AskFollowUpButton";
  ClickMetricsNames["DocumentUploadButton"] = "DocumentUploadButton";
  ClickMetricsNames["PromptInputExpandButton"] = "PromptInputExpandButton";
  ClickMetricsNames["AddInSourceTextButton"] = "AddInSourceTextButton";
  ClickMetricsNames["AddInSourceWorldKnowledgeButton"] = "AddInSourceWorldKnowledgeButton";
  ClickMetricsNames["AddInSourceEmailWithAttachmentsButton"] = "AddInSourceEmailWithAttachmentsButton";
  ClickMetricsNames["AddInSourceEmailButton"] = "AddInSourceEmailButton";
  ClickMetricsNames["AddInSourceAttachmentsButton"] = "AddInSourceAttachmentsButton";
  ClickMetricsNames["MessageReferences"] = "MessageReferences";
})(ClickMetricsNames || (ClickMetricsNames = {}));
var LoadedMetricNames;
(function (LoadedMetricNames) {
  LoadedMetricNames["StandaloneRenderCount"] = "StandaloneRenderCount";
  LoadedMetricNames["AddOnRenderCount"] = "AddOnRenderCount";
  LoadedMetricNames["MFECompanionCount"] = "MFECompanionCount";
  LoadedMetricNames["PlaygroundLoad"] = "PlaygroundLoad";
  LoadedMetricNames["CustomChatBotLoad"] = "CustomChatBotLoad";
  LoadedMetricNames["LoadingHistorySuccessfully"] = "LoadingHistorySuccessfully";
})(LoadedMetricNames || (LoadedMetricNames = {}));
var ErrorMetricNames;
(function (ErrorMetricNames) {
  ErrorMetricNames["MessageError"] = "MessageError";
  ErrorMetricNames["DocumentsParsingErrors"] = "DocumentsParsingErrors";
  ErrorMetricNames["FailedToLoadHistory"] = "FailedToLoadHistory";
  ErrorMetricNames["UnknownErrors"] = "UnknownErrors";
  ErrorMetricNames["GenAIRequestApiFailed"] = "GenAIRequestApiFailed";
  ErrorMetricNames["UnknownMessageErrors"] = "UnknownMessageErrors";
})(ErrorMetricNames || (ErrorMetricNames = {}));
var MetricNames = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, ClickMetricsNames), MiscMetricNames), ErrorMetricNames), LoadedMetricNames), InitiatedMetricNames), ChangedEventMetricNames);

export { AttachmentType, ChangedEventMetricNames, ClickMetricsNames, ContentType, DownloadContentType, DownloadDocumentType, ErrorMetricNames, InitiatedMetricNames, LegalAIMetricType, LegalAiCompanionEventNames, LegalAiStandAloneEventNames, LoadedMetricNames, MetricEventType, MetricNames, MiscMetricNames, SkillType, Stage };
//# sourceMappingURL=index.js.map
